import React from "react";

const PrivacyPolicyDe = () => {
  return (
    <div style={{ padding: "48px", lineHeight: "1.6", fontFamily: "Arial, sans-serif" }}>
      <h1>Datenschutzerklärung für Fotogram Technology</h1>
      <p><strong>Stand:</strong> 22.11.2024</p>

      <section>
        <h2>1. Verantwortlicher und Kontakt</h2>
        <p>
          <strong>Verantwortlich für die Datenverarbeitung:</strong>
          <br />
          Fotogram Technology
          <br />
          CEO: Eilon Mario Netzer
          <br />
          Adresse: 1004 Street Building 18, PO Box 50255, 1616102 Nazareth, Israel
          <br />
          E-Mail: <a href="mailto:info@fotogram.app">info[at]fotogram.app</a>
          <br />
          Website: <a href="https://fotogram.technology" target="_blank" rel="noopener noreferrer">fotogram.technology</a>
        </p>
      </section>

      <section>
        <h2>2. Datenverarbeitung ausschließlich in Deutschland</h2>
        <h3>2.1 Standort der Server</h3>
        <p>
          Die von Fotogram Technology erhobenen Daten werden ausschließlich auf Servern in Deutschland gespeichert und verarbeitet. Die Server erfüllen die Anforderungen der DSGVO und garantieren höchste Sicherheitsstandards.
        </p>
        <h3>2.2 Kein Datentransfer ins Ausland</h3>
        <p>
          Israel wurde von der Europäischen Kommission als Drittland mit angemessenem Datenschutzniveau anerkannt (Art. 45 DSGVO). 
          Dennoch findet bei Fotogram Technology keine Übertragung personenbezogener Daten nach Israel statt, 
          da sämtliche Datenverarbeitung ausschließlich auf Servern in Deutschland erfolgt.
        </p>
      </section>

      <section>
        <h2>3. Kategorien personenbezogener Daten</h2>
        <p>Wir verarbeiten folgende personenbezogene Daten:</p>
        <ul>
          <li>
            <strong>Nutzungsdaten:</strong> IP-Adresse, Browsertyp, Betriebssystem, Zugriffszeit.
          </li>
          <li>
            <strong>Kundendaten:</strong> Name, E-Mail-Adresse, Telefonnummer, Adressdaten, Zahlungsinformationen.
          </li>
          <li>
            <strong>Inhaltsdaten:</strong> Hochgeladene Bilder, Videos und Kommentare.
          </li>
          <li>
            <strong>Kommunikationsdaten:</strong> Inhalte von Supportanfragen, Kontaktformulare.
          </li>
          <li>
            <strong>Technische Daten:</strong> Geräteinformationen, Logdaten.
          </li>
        </ul>
      </section>

      <section>
        <h2>4. Zwecke und Rechtsgrundlagen der Verarbeitung</h2>
        <h3>4.1 Zwecke der Verarbeitung</h3>
        <p>Die Datenverarbeitung erfolgt zu folgenden Zwecken:</p>
        <ul>
          <li>Bereitstellung und Verbesserung unserer Dienste.</li>
          <li>Verwaltung von Nutzerkonten und Vertragsbeziehungen.</li>
          <li>Zahlungsabwicklung.</li>
          <li>Analyse und Optimierung der Website-Nutzung.</li>
          <li>Erfüllung rechtlicher Verpflichtungen.</li>
        </ul>
        <h3>4.2 Rechtsgrundlagen der Verarbeitung</h3>
        <p>Die Verarbeitung basiert auf:</p>
        <ul>
          <li>
            <strong>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung):</strong> z. B. für Newsletter oder Cookies.
          </li>
          <li>
            <strong>Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung):</strong> z. B. für Kundenkonten und Dienste.
          </li>
          <li>
            <strong>Art. 6 Abs. 1 lit. c DSGVO (rechtliche Verpflichtung):</strong> z. B. für steuerliche Anforderungen.
          </li>
          <li>
            <strong>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse):</strong> z. B. für die Sicherheit und Analyse.
          </li>
        </ul>
      </section>

      <section>
        <h2>5. Cookies und ähnliche Technologien</h2>
        <h3>5.1 Arten von Cookies</h3>
        <p>Unsere Website verwendet:</p>
        <ul>
          <li>Essenzielle Cookies: Notwendig für die Grundfunktionen der Website.</li>
          <li>Funktionale Cookies: Ermöglichen zusätzliche Funktionen wie Benutzerpräferenzen.</li>
          <li>Analyse-Cookies: Sammeln anonymisierte Nutzungsstatistiken.</li>
          <li>Marketing-Cookies: Dienen der personalisierten Werbung.</li>
        </ul>
        <h3>5.2 Verwaltung von Cookies</h3>
        <p>
          Sie können Ihre Cookie-Präferenzen jederzeit in den Einstellungen Ihres Browsers oder über unser Cookie-Banner anpassen.
        </p>
      </section>

      <section>
        <h2>6. Datenverarbeitung bei der Nutzung unserer Dienste</h2>
        <h3>6.1 Registrierung und Kundenkonto</h3>
        <p>
          Bei der Registrierung erheben wir:
          <ul>
            <li>Name, E-Mail-Adresse, Passwort.</li>
            <li>Optional: Zahlungsinformationen.</li>
          </ul>
          <strong>Zweck:</strong> Verwaltung Ihres Kontos und Bereitstellung der Dienste.
          <br />
          <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO.
        </p>
        <h3>6.2 Kontaktformular und Supportanfragen</h3>
        <p>
          Bei der Nutzung des Kontaktformulars oder der Supportfunktion speichern wir:
          <ul>
            <li>Ihre Nachricht, Name, E-Mail-Adresse.</li>
          </ul>
          <strong>Zweck:</strong> Bearbeitung Ihrer Anfrage.
          <br />
          <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO.
        </p>
      </section>

      <section>
        <h2>7. Drittanbieter und Auftragsverarbeiter</h2>
        <p>
          Wir arbeiten mit Drittanbietern zusammen, die uns bei der Bereitstellung unserer Dienste unterstützen:
        </p>
        <ul>
          <li>
            <strong>Hosting-Anbieter:</strong> Unsere Server in Deutschland werden von zertifizierten Hosting-Anbietern betrieben, die DSGVO-konform arbeiten.
          </li>
        </ul>
      </section>

      <section>
        <h2>8. Kontakt für Datenschutzfragen</h2>
        <p>
          <strong>Fotogram Technology</strong>
          <br />
          E-Mail: <a href="mailto:info@fotogram.app">info[at]fotogram.app</a>
        </p>
      </section>
      
      <section>
        <h2>9. Rechte der betroffenen Personen</h2>
        <p>Als betroffene Person haben Sie folgende Rechte:</p>
        <ul>
          <li>Auskunft über Ihre bei uns gespeicherten Daten (Art. 15 DSGVO)</li>
          <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
          <li>Löschung („Recht auf Vergessenwerden“) Ihrer Daten (Art. 17 DSGVO)</li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
          <li>Widerruf einer Einwilligung jederzeit mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO)</li>
          <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
        </ul>
      </section>

    </div>
  );
};

export default PrivacyPolicyDe;
